// import axios from "axios";

// export type StudentCertificate = {
//   _id: string;
//   certificateNumber: string;
//   recipientName: string;
//   courseOrEventName?: string;
//   issueDate: string;
//   originalFileName: string;
//   mimeType: string;
//   metadata?: {
//     rollNumber?: string;
//     email?: string;
//     branch?: string;
//     section?: string;
//   };
// };

// type MyCertificatesResponse = {
//   certificates: StudentCertificate[];
// };

// const CERTIFICATES_API_BASE = "/api/integration/external-service/certificates";

// export const fetchMyCertificates = async (): Promise<StudentCertificate[]> => {
//   const response = await axios.get<MyCertificatesResponse>(`${CERTIFICATES_API_BASE}/my`);
//   return Array.isArray(response.data?.certificates) ? response.data.certificates : [];
// };

// export const downloadMyCertificate = async (
//   certificateNumber: string,
//   fileName: string,
// ): Promise<void> => {
//   const response = await axios.get(
//     `${CERTIFICATES_API_BASE}/${encodeURIComponent(certificateNumber)}/download`,
//     { responseType: "blob" },
//   );

//   const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
//   const link = document.createElement("a");
//   link.href = blobUrl;
//   link.setAttribute("download", fileName || `${certificateNumber}.pdf`);
//   document.body.appendChild(link);
//   link.click();
//   link.remove();
//   window.URL.revokeObjectURL(blobUrl);
// };


import axios from "axios";

export type StudentCertificate = {
  _id: string;
  certificateNumber: string;
  recipientName: string;
  courseOrEventName?: string;
  issueDate: string;
  originalFileName: string;
  mimeType: string;
  metadata?: {
    rollNumber?: string;
    email?: string;
    branch?: string;
    section?: string;
  };
};

type MyCertificatesResponse = {
  certificates: StudentCertificate[];
};

const CERTIFICATES_API_BASE = "/api/integration/external-service/certificates";

export const fetchMyCertificates = async (): Promise<StudentCertificate[]> => {
  const response = await axios.get<MyCertificatesResponse>(`${CERTIFICATES_API_BASE}/my`);
  return Array.isArray(response.data?.certificates) ? response.data.certificates : [];
};

export const downloadMyCertificate = async (
  certificateNumber: string,
  fileName: string,
): Promise<void> => {
  const response = await axios.get(
    `${CERTIFICATES_API_BASE}/${encodeURIComponent(certificateNumber)}/download`,
    { responseType: "blob" },
  );
  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", fileName || `${certificateNumber}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

// Returns the raw Blob so the caller can create an object URL for in-browser preview.
// Uses the same endpoint as downloadMyCertificate — no backend changes needed.
export const previewMyCertificate = async (certificateNumber: string): Promise<Blob> => {
  const response = await axios.get(
    `${CERTIFICATES_API_BASE}/${encodeURIComponent(certificateNumber)}/download`,
    { responseType: "blob" },
  );
  return new Blob([response.data as BlobPart], {
    // Prefer the Content-Type the server sent; fall back to PDF
    type: (response.headers["content-type"] as string | undefined) ?? "application/pdf",
  });
};